import { App } from './app'
import { getFirestore, addDoc, collection, doc, setDoc, getDoc } from 'firebase/firestore'

const DB = getFirestore(App)

export { DB, addDoc, collection, doc, setDoc, getDoc }
